module.exports = __webpack_public_path__ + "static/media/isp_logo.e01768cd.png";